import type { VoiceSessionOrigin } from './voiceSessionStorage';
import {
  resolveAssistantPageKey,
  resolveNavigationSegment,
  type AssistantPageKey,
} from '../constants/assistantSuggestedQueries';

export interface AssistantRouteContext {
  pathname: string;
  search: string;
  pageKey: AssistantPageKey;
  navigationKey: string;
}

export function buildAssistantRouteContext(pathname: string, search = ''): AssistantRouteContext {
  return {
    pathname,
    search,
    pageKey: resolveAssistantPageKey(pathname, search),
    navigationKey: resolveNavigationSegment(pathname),
  };
}

export function buildVoiceSessionOrigin(pathname: string, search = ''): VoiceSessionOrigin {
  const route = buildAssistantRouteContext(pathname, search);
  return {
    pathname: route.pathname,
    search: route.search,
    pageKey: route.pageKey,
  };
}

export function formatSessionOriginLabel(
  origin: VoiceSessionOrigin | undefined,
  translate: (key: string) => string
): string | undefined {
  if (!origin) return undefined;
  const navKey = resolveNavigationSegment(origin.pathname);
  return translate(`navigation.${navKey}`);
}
